export function resolveVisibility(storage, uuid){
  if (document.visibilityState === 'visible') {
    // check the cookie / storage sessionUUID === this.instanceUUID
    const uuidJSON = storage.getItem('lilberd-active-uuid')
    if (uuidJSON){
      const storedUUID = JSON.parse(uuidJSON)
      if (storedUUID !== uuid){
        // session was updated in alternate tab / window
        // throw modal at user to reload the page
        this.$customModal.show('reload-modal')
      }else{
        // session is still current session
        // do nothing, we good
      }
    }
  } else {
    // assume leaving tab
    // Set the cookie / storage sessionUUID to be this.instanceUUID
    storage.setItem('lilberd-active-uuid', JSON.stringify(uuid))
  }
}
